export default __webpack_public_path__ + "static/media/2_icon2B.76dedc73.png";